export function createAnalyticsEventBody(presentationId: number | null, ...args) {
    return ({
        presentationId,
        events: [...args]
    })
}

